<template>
  <div class="addSetContainer">
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="上级项目">
        <a-select
          showSearch
          :filterOption="filterOption"
          v-model="selectedOneVal"
          @change="selectedOne"
          placeholder="请选择项目"
          style="width: 160px; margin-right: 10px"
        >
          <a-select-option
            :value="item.id"
            v-for="(item, i) in proListOne"
            :key="i + 't'"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
        <a-select
          @change="selectedTwo"
          v-model="selectedTwoVal"
          showSearch
          :filterOption="filterOption"
          placeholder="请选择项目"
          style="width: 160px"
        >
          <a-select-option
            :value="item.id"
            v-for="(item, i) in proListTwo"
            :key="i + 'j'"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="关联项目" prop="project_list">
        <a-select
          :maxTagCount="10"
          mode="multiple"
          style="width: 86%; margin-right: 10px"
          v-model="project_list"
          showSearch
          :filterOption="filterOption"
          placeholder="请选择关联项目"
        >
          <a-select-option
            :value="item.id"
            v-for="(item, i) in proListThree"
            :key="i + 'c'"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
        <span>
          <a-checkbox :checked="checked" @change="selectedAll">全选</a-checkbox>
        </span>
      </a-form-model-item>
      <a-form-model-item label="岗位">
        <a-radio-group v-model="form.roleVal">
          <a-radio
            v-for="(item, i) in roleList"
            :key="i"
            :value="Number(item.id)"
          >
            {{ item.role_name }}
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="结算方式" prop="type">
        <a-radio-group v-model="form.type">
          <a-radio :value="1">出勤天数常规结算</a-radio>
          <a-radio :value="2">出勤天数阶梯结算</a-radio>
          <a-radio :value="4">时新结算</a-radio>
          <a-radio :value="5">订单/工单结算</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <!-- 模版一 -->
      <a-form-model-item label="在岗天数" v-show="form.type == 1">
        <a-input-number />
        <span>&nbsp;天</span>
      </a-form-model-item>
      <!-- 模版 end一 -->
      <!-- 模版二 -->
      <a-form-model-item
        style="vertical-align: middle"
        v-show="form.type == 2"
        label="阶梯"
      >
        <div v-for="(element, i) in three_ladder" :key="i + '1'">
          <span>累计人数&nbsp;&nbsp;</span>
          <a-input-number v-model="element.min" :min="0" />
          <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span>累计人数&nbsp;&nbsp;</span>
          <a-input-number v-model="element.max" :min="element.min + 1" />
          <a-icon
            @click="addLadder(i, element.txt)"
            style="
              font-size: 32px;
              color: #999;
              vertical-align: middle;
              margin-left: 10px;
            "
            :type="element.txt == '增加' ? 'plus-square' : 'minus-square'"
          />
        </div>
      </a-form-model-item>
      <a-form-model-item
        v-show="element.max != '' && form.type == 2 && element.max != null"
        v-for="(element, j) in three_ladder"
        :key="j + 'element'"
        style="vertical-align: middle"
        label="服务费"
      >
        <span>{{
          element.min + "&nbsp;~&nbsp;" + element.max + "&nbsp;人&nbsp;&nbsp;"
        }}</span>
        <a-input-number
          v-model="element.price"
          :min="0"
          style="margin-right: 10px"
        />
        <span>元</span>
      </a-form-model-item>
      <!-- 模版二 end -->
      <!-- 模版四 -->

      <a-form-model-item label="每小时" v-show="form.type == 4">
        <a-input-number />
        <span>&nbsp;元</span>
      </a-form-model-item>
      <!-- 模版四 end -->
      <!-- 模版五 -->
      <a-form-model-item label="每单" v-show="form.type == 5">
        <a-input-number />
        <span>&nbsp;元</span>
      </a-form-model-item>
      <!-- 模版五 end -->
      <a-form-model-item label="结算周期">
        <a-radio-group v-model="form.dateType">
          <a-radio
            :value="item.id"
            v-for="(item, k) in dateTypeText"
            :key="k + 'k'"
            >{{ item.name }}</a-radio
          >
        </a-radio-group>
      </a-form-model-item>

      <!-- 一次性结算 长返 -->

      <a-form-model-item
        label="服务费"
        v-show="form.dateType == 1 || form.dateType == 3"
      >
        <a-input-number :min="0" />
        <span>&nbsp;元</span>
      </a-form-model-item>
      <!-- 一次性结算  长返 end -->
      <!-- 限制截止日期 -->
      <a-form-model-item label="连续返费" v-show="form.dateType == 2">
        <a-input-number :min="0" v-model="form.monthCost" />
        <span>&nbsp;月</span>
      </a-form-model-item>
      <a-form-item
        v-show="
          form.dateType == 2 && form.monthCost != '' && form.monthCost > 0
        "
        v-for="(element, i) in costList"
        :key="i + 'i'"
        :label="'第' + (i + 1) + '个月服务费'"
      >
        <a-input-number v-model="costList[i]" />
        <span>&nbsp;元</span>
      </a-form-item>
      <!-- 限制截止日期 end -->
      <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
        <a-button @click="resetForm"> 重置 </a-button>
        <a-button style="margin-left: 20px" type="primary" @click="onSubmit"
          >提交</a-button
        >
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        type: 1,
        dateType: "",
        monthCost: "",
        project_id: [],
        roleVal: ""
      },
      rules: {
        type: [
          {
            required: true,
            message: "请选择结算方式",
            trigger: "change"
          }
        ],
        project_list: [
          {
            required: true,
            message: "请选择项目",
            trigger: "change"
          }
        ]
      },
      three_ladder: [{ min: 0, max: "", txt: "增加", price: "" }],
      costList: [],
      disabled: false,
      dateTypeText: [
        {
          name: "一次性结算",
          id: 1
        },
        {
          name: "限制截止日期",
          id: 2
        },
        {
          name: "长返",
          id: 3
        }
      ],
      proListOne: [],
      proListTwo: [],
      proListThree: [],
      isShowTwo: false,
      selectedOneVal: "",
      selectedTwoVal: "",
      selectedThreeVal: "",
      checked: false,
      project_list: [],
      thirdList: [],
      roleList: []
    };
  },
  computed: {
    monthCostComputed() {
      return this.form.monthCost;
    }
  },
  mounted() {
    this.getProOne(); //获取一级项目列表
    this.getPro();
    this.getThirdParty(); //三方公司
  },
  watch: {
    monthCostComputed() {
      if (Number(this.form.monthCost) > 0) {
        this.costList.length = Number(this.form.monthCost);
      }
    }
  },
  methods: {
    projectVal() {
      this.form.user_ids = [];
      this.getRole();
    },
    getRole() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.people +
        "Account_config/getProjectEntryRole";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: this.form.project_id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.roleList = res.data.data;
            // console.log(this.roleList);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    getThirdParty() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Third_part/thirdPartList";
      let pramas = {
        per_page: 10000,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, pramas).then(res => {
        if (res.data.code == 200) {
          this.thirdList = res.data.data.data;
          // console.log(this.thirdList);
        }
      });
    },
    selectedAll(e) {
      this.checked = e.target.checked;
      if (this.selectedOneVal == "") {
        this.project_list = [];
      }
      if (e.target.checked) {
        this.proListThree.forEach(element => {
          if (this.project_list.indexOf(element.id) == -1) {
            // console.log(element.id)
            this.project_list.push(element.id);
          }
          // console.log(element)
        });
      } else {
        this.project_list = [];
      }
    },
    selectedOne(id) {
      this.checked = false;
      this.isShowTwo = true;
      this.selectedTwoVal = "";
      this.getProID(id, 1); //获取下级项目
      this.getThreePro(id);
      // console.log(id);
    },
    selectedTwo(id) {
      this.checked = false;
      this.isShowThree = true;
      this.getProID(id, 2); //获取下级项目
    },
    getThreePro(id) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/projectListByProjectTop";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListThree = res.data.data;
            // console.log(this.proListThree);
          }
        });
    },
    getProOne() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/projectListByLevel";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          level: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListOne = res.data.data;
            // console.log(this.proList);
          }
        });
    },
    getProID(id, level) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/projectListByProjectId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            if (level == 1) {
              this.proListTwo = res.data.data;
            } else if (level == 2) {
              this.proListThree = res.data.data;
            }
            // console.log(this.proList);
          }
        });
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListThree = res.data.data;
            // console.log(this.proListThree);
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onSubmit() {},
    resetForm() {},
    addLadder(index, txt) {
      if (txt == "增加") {
        if (this.three_ladder[this.three_ladder.length - 1].max != "") {
          this.three_ladder.push({
            min: this.three_ladder[this.three_ladder.length - 1].max,
            max: "",
            txt: "减少",
            price: ""
          });
        } else {
          this.$message.error("请先填写最大值！");
        }
      } else {
        this.three_ladder.splice(index, 1);
      }
    }
  }
};
</script>
<style lang="less">
.addSetContainer {
  margin: 50px 2%;
  padding-bottom: 30px;
  .ant-form-item {
    margin-bottom: 14px;
  }
  .ant-form-item label {
    margin-bottom: 10px;
  }
  .area-select .area-selected-trigger {
    padding: 0 20px 0 12px;
  }
  .area-select {
    line-height: 32px;
  }
  .area-select.medium {
    width: 142px;
  }
}
</style>
